import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import PanelChrome from './PanelChrome';
import './styles.less';

const DockPanel = ({
	className,
	panelClassName,
	visible,
	dockWidth,
	isInteracting,
	startLeftResize,
	header,
	children,
	zIndex = 1050
}) => {
	if (!visible) {
		return null;
	}

	return (
		<div
			className={cx('dock-panel', panelClassName, className, {
				'dock-panel--interacting': isInteracting
			})}
			style={{ width: dockWidth, zIndex }}
			role='dialog'
		>
			<div
				className='dock-panel__resize-handle'
				onPointerDown={startLeftResize}
				aria-label='Resize docked panel'
			/>
			<PanelChrome isInteracting={isInteracting} header={header}>
				{children}
			</PanelChrome>
		</div>
	);
};

DockPanel.propTypes = {
	className: PropTypes.string,
	panelClassName: PropTypes.string,
	visible: PropTypes.bool,
	dockWidth: PropTypes.number.isRequired,
	isInteracting: PropTypes.bool,
	startLeftResize: PropTypes.func.isRequired,
	header: PropTypes.node.isRequired,
	children: PropTypes.node,
	zIndex: PropTypes.number
};

export default DockPanel;
